import { UNEMPLOYMENT_REL_URL } from 'consts/appConsts';
import { UNEMPLOYMENT_WIZARD } from 'consts/queryParameterConsts';

import parseWindowPath from 'utils/parseWindowPath';
import { UNEMPLOYMENT_WIZARD_QSP } from 'utils/queryParamHelpers';

const regex = new RegExp(`^/${UNEMPLOYMENT_WIZARD}/?$`);
const isUnemploymentWizard =
  parseWindowPath().test(regex) || Boolean(UNEMPLOYMENT_WIZARD_QSP);

export const unemploymentRedirect = () => {
  if (isUnemploymentWizard) {
    window.location.href = UNEMPLOYMENT_REL_URL;
  }
};
